<template>
    <div class="biz-house-mgt-frame parent-frame">
        <div class="biz-house-mgt-frame-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss">
    .biz-house-mgt-frame{
        position: relative;
        .biz-house-mgt-frame-wrap{
            padding: 0 30px 30px 30px;
            width:  calc(1180px - 40px);
        }
    }
    // @media screen and (max-width: 1280px){
    //     .biz-house-mgt-frame{
    //         .biz-house-mgt-frame-wrap{
    //             width:  1060px;
    //         }
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/mgtCategoryFrame.vue